module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm_headab"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig_10"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rtit"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Titlepage#tit"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Dedication#ded"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rfm1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Foreword#fm1"
    }
  }, [_c('i', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rfm2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Preface#fm2"
    }
  }, [_c('i', [_vm._v("Preface: My Fifty Years with James Thurber")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Part_1#pt1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Part_1#pt1"
    }
  }, [_vm._v("Stories Not Collected Before in Book Form:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_1#ch1"
    }
  }, [_vm._v("The Lady on 142")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_2#ch2"
    }
  }, [_vm._v("The Catbird Seat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_3#ch3"
    }
  }, [_vm._v("Memoirs of a Drudge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cane in the Corridor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secret Life of James Thurber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recollections of the Gas Buggy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("My World and Welcome to It:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Do You Mean It Was Brillig?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secret Life of Walter Mitty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here Lies Miss Groby")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man Who Hated Moonbaum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Macbeth Murder Mystery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Ride With Olympy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("Let Your Mind Alone!:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destructive Forces in Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex Ex Machina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Breaking Up of the Winships")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Admiral on the Wheel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Couple of Hamburgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bateman Comes Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doc Marlowe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wood Duck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("The Middle-Aged Man on the Flying Trapeze:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Departure of Emma Inch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s an Owl in My Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Topaz Cufflinks Mystery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snapshot of a Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Something to Say")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curb in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Black Magic of Barney Haller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If Grant Had Been Drinking at Appomattox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Remarkable Case of Mr. Bruhl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Luck of Jad Peters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Greatest Man in the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evening’s at Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One is a Wanderer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("My Life and Hard Times,")]), _vm._v(" complete:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface to a Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Night the Bed Fell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Car We Had to Push")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Day the Dam Broke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Night the Ghost Got In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Alarms at Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sequence of Servants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dog That Bit People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("University Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Draft Board Nights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note at the End")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt6"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_6#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_6#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("Fables for Our Time")]), _vm._v(" and "), _c('i', [_vm._v("Famous Poems Illustrated:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birds and the Foxes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Little Girl and the Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scotty Who Knew Too Much")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Very Proper Gander")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bear Who Let It Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shrike and the Chipmunks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seal Who Became Famous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crow and the Oriole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moth and the Star")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Glass in the Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rabbits Who Caused All the Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Owl Who Was God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unicorn in the Carden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excelsior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Oh When I was . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbara Frietchie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sands o’ Dee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curfew Must Not Ring Tonight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_7#pt7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_7#pt7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("The Owl in the Attic:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pet Department")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#pt8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#pt8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("The Seal in the Bedroom:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“With You I Have Known Peace, Lida, and Now You Say You’re Going Crazy”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Are You the Young Man That Bit My Daughter?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Here’s a Study for You, Doctor—He Faints”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Mamma Always Gets Sore and Spoils the Game for Everybody”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“For the Last Time—You and Your Horsie Get Away from Me and Stay Away!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Well, What’s Come Over "), _c('i', [_vm._v("You")]), _vm._v(" Suddenly?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Have You People Got Any .38 Cartridges?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch71"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Father Belonged to Some People Who Were Driving Through in a Packard”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Stop Me!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I Don’t Know. George Got It Somewhere”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_8#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“All Right, Have It Your Way—You Heard a Seal Bark”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mib",
    attrs: {
      "id": "rch75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_64#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bloodhound and the Bug")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part",
    attrs: {
      "id": "rpt9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#pt9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#pt9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('i', [_vm._v("Men, Women and Dogs:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“This is Not the Real Me You’re Seeing, Mrs. Clisbie”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“What’s Come Over You Since Friday, Miss Schemke?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Hello, Darling—Woolgathering?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“It’s a Naїve Domestic Burgundy Without Any Breeding, But I Think You’ll Be Amused by Its Presumption”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Oh, Doctor "), _c('i', [_vm._v("Conroy—Look")]), _vm._v("!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I’d Feel a Great Deal Easier If Her Husband Hadn’t Gone to Bed”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Touché!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“And This Is Tom Weatherby, an Old Beau of Your Mother’s. He Never Got to First Base”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Perhaps "), _c('i', [_vm._v("This")]), _vm._v(" Will Refresh Your Memory”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“. . . And Keep Me a Normal, Healthy, American Girl”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“It’s Parkins, Sir; We’re ’Aving a Bit of a Time Below Stairs”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Darling, I Seem to Have This Rabbit”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“That’s My First Wife Up There, and This Is the "), _c('i', [_vm._v("Present")]), _vm._v(" Mrs. Harris”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“You’re Not My Patient, You’re My Meat, Mrs. Quist!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“She Has the True Emily Dickinson Spirit Except That She Gets Fed Up Occasionally”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I Said the Hounds of Spring Are on Winter’s Traces—But Let It Pass, Let It Pass!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“For Heaven’s Sake, Why Don’t You Go Outdoors and Trace Something?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I Don’t Want Him to Be Comfortable If He’s Going to Look Too Funny.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Yoo-hoo, It’s Me and the Ape Man”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Look Out! Here They Come Again!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“You Wait Here and I’ll Bring the Etchings Down”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch97"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Well, Who "), _c('i', [_vm._v("Made")]), _vm._v(" the Magic Go Out of Our Marriage—You or Me?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House and Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Well, If I Called the Wrong Number, Why Did You Answer the Phone?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“This Gentleman Was Kind Enough to See Me Home, Darling”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I Come From Haunts of Coot and Hern!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Well, I’m Disenchanted, Too. We’re "), _c('i', [_vm._v("All")]), _vm._v(" Disenchanted”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“What Do You Want to Be Inscrutable "), _c('i', [_vm._v("for,")]), _vm._v(" Marcia?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“You Said a Moment Ago That Everybody You Look at Seems to Be a Rabbit. Now Just What Do You Mean by That, Mrs. Sprague?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Why, I Never Dreamed Your Union Had Been Blessed With Issue!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Have You Seen My Pistol, Honey-bun?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“It’s Our "), _c('i', [_vm._v("Own")]), _vm._v(" Story "), _c('i', [_vm._v("Exactly")]), _vm._v("! He Bold as a Hawk, She Soft as the Dawn”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“You and Your Premonitions!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“All Right, All Right, Try It That Way! Go Ahead and Try It That Way!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Well, It Makes a Difference to "), _c('i', [_vm._v("Me")]), _vm._v("!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“There’s No Use You Trying to Save "), _c('i', [_vm._v("Me,")]), _vm._v(" My Good Man”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man in Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi",
    attrs: {
      "id": "rch113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Part_9#ch113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“What Have You Done With Dr. Millmoss?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_en",
    attrs: {
      "id": "rch114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Chapter_65#ch114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War Between Men and Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rbm1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About James Thurber")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rbm2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Backmatter_1#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Thurber Carnival, "), _c('i', [_vm._v("1945")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rals"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Also#als",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Also by James Thurber")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rcop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063075771_Copyright#cop",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "ratp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5d661a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780063075771_Contents.vue
// module id = 66
// module chunks = 0